import React from "react";

import provenResultsArcImg from '../../../../assets/images/provenResultsArc.png';
import provenResultsArcImgMobile from '../../../../assets/images/provenResultsArcMobile.png';

import { Row, Col } from "reactstrap";

import './style.scss'; 

export default function Results () {
    return (
        <Row className="results">
            <Col xs={12} md={6}>
                <h2 className="heading-2">Proven Results</h2>
                <div className="body-text-big mb-4">At DevsMore we believe that success is measurable. Our focus on delivering tangible results sets us apart: </div>
                <div className="pink-text-container">
                    <span className="text-bold-color">Client-Centric Approach: </span>
                    <span className="body-text-big">We work closely with you to understand your business objectives and tailor our solutions to ensure alignment with your goals.</span>
                </div>
                <div className="pink-text-container">
                    <span className="text-bold-color">Success Stories: </span>
                    <span className="body-text-big"> Our track record speaks for itself. We have helped numerous clients achieve their IT objectives, streamline operations, and enhance productivity.</span>
                </div>
                <div className="pink-text-container">
                    <span className="text-bold-color">Continuous Improvement: </span>
                    <span className="body-text-big">We are committed to learning and evolving. By leveraging the latest technologies and methodologies, we ensure that our solutions remain relevant and effective in a constantly changing market.</span>
                </div>
                <img src={provenResultsArcImg} className="proven-results-arc" alt="results arc"/>
                <img src={provenResultsArcImgMobile} className="proven-results-arc-mobile" alt="results arc mobile"/>
            </Col>
        </Row>
    )
}
